module.exports = __webpack_public_path__ + "img/result_wine_c.f5e29436.png";